import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import { first } from 'lodash';

const UserIcon = ({ bgcolor, firstName, lastName, sx = {} }) => {
  const theme = useTheme();
  return (
    <Avatar
      sx={{
        bgcolor,
        color: theme.palette.getContrastText(bgcolor),
        boxShadow: '1px 2px 7px grey',
        p: 2.5,
        ...sx,
      }}
      alt={first(firstName)}
    >
      {first(firstName).toUpperCase()}
      {first(lastName).toUpperCase()}
    </Avatar>
  );
};

UserIcon.propTypes = {
  bgcolor: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  sx: PropTypes.shape({}),
};

UserIcon.defaultProps = {
  sx: {},
};

export default UserIcon;
